module.exports = __webpack_public_path__ + "static/media/20180608_161910.964c377f.jpg";